import get from 'lodash/get'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppStateType } from '../../reducers'
import { selectPack } from '../../selectors/pack'
import {
  selectCapabilitiesSummaryPerGroup,
  selectIsLightGroup,
} from '../../selectors/capabilitiesSummary'
import { selectGroupById } from '../../selectors/groups'
import { PackPage as Page } from './PackPage'

const mapStateToProps = (state: AppStateType, ownProps) => {
  const groupId = get(ownProps, 'match.params.groupId', '')
  return {
    pack: selectPack(state),
    capabilitiesSummary: selectCapabilitiesSummaryPerGroup(groupId)(state),
    isLightGroup: selectIsLightGroup(state, groupId),
    group: selectGroupById(groupId)(state),
    groupsLoading: state.groups.isLoading,
    groupsLoaded: state.groups.isLoaded,
  }
}

export const PackPage = withRouter(
  connect(mapStateToProps)(Page)
) as React.FC<{}>
